var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader-container"},[_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',[_c(_setup.PulseLoader,{attrs:{"loading":true,"size":"7px","color":_vm.constants.spinnerColor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }